import Vue from 'vue'
import VueI18n from 'vue-i18n'
import globalMessages from '@rhitics/core/locales'

Vue.use(VueI18n)

export function createI18n(options: VueI18n.I18nOptions) {
  if (options.messages) {
    Object.keys(globalMessages).forEach(lang => {
      if (options.messages) {
        options.messages[lang] = Object.assign(globalMessages[lang], options.messages[lang])
      }
    })
  } else {
    options.messages = globalMessages
  }

  if (options.locale === undefined) {
    options.locale = 'en'
  }

  if (options.fallbackLocale === undefined) {
    options.fallbackLocale = 'en'
  }

  const i18n = new VueI18n(options)

  return i18n
}
